import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast, useAuth } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIS, URLS, SF_INTF_DOC_MGMT_SRCH, SG_INTF_DOC_MGMT_SRCH } from "./services/OsciIntfDocMgmtService";

/*
 * Interface Document Management
 * !== 인터페이스 문서 관리 ==!
 */
export const OSCI0113008Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const [intfDocMgmtLstData, setIntfDocMgmtLstData] = useState(comnUtils.getGridData([]));

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0164" }, // 내외부 유형 코드
            { area: "comnCd", comnCd: "OSC0088" }, // 업무 분류 코드
            { area: "comnCd", comnCd: "OSC0101" }, // 사용 여부 코드
            { area: "comnCd", comnCd: "OSC0104" }, // 송수신 유형 코드
            { area: "comnCd", comnCd: "OSC0109" }, // 송수신 구분 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        intfDocMgmtSrch: useForm({
            defaultSchema: SF_INTF_DOC_MGMT_SRCH,
        }),
    };

    const grid = {
        intfDocMgmtSrch: useGrid({
            defaultSchema: SG_INTF_DOC_MGMT_SRCH,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get a list of document box. !== 문서함 목록을 조회한다. ==!
        getIntfDocMgmtLst: useFetch({
            api: (page = grid.intfDocMgmtSrch.page) =>
                APIS.getIntfDocMgmtLst(form.intfDocMgmtSrch.getValues(), page, grid.intfDocMgmtSrch.size),
            enabled: comnUtils.isEmpty(form.intfDocMgmtSrch.errors),
            key: [grid.intfDocMgmtSrch.page, grid.intfDocMgmtSrch.size],
            onSuccess: (data) => {
                setIntfDocMgmtLstData(data.intfDocLst);
                setStore(pgeUid, {
                    form: form.intfDocMgmtSrch.getValues(),
                    page: grid.intfDocMgmtSrch.page,
                    size: grid.intfDocMgmtSrch.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        getIntfDocMgmtLst: (page: number = 0) => {
            form.intfDocMgmtSrch.handleSubmit(
                () => {
                    grid.intfDocMgmtSrch.setPage(page);
                    fetch.getIntfDocMgmtLst.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_intfDocMgmtSrch: {
            cell: {
                intfId: (props: any) => {
                    const { rowValues, value } = props;
                    return <Link to={`${URLS.osci0113010s}/${rowValues.intfId}`}>{value}</Link>;
                },
            },
        },
    };

    const kwdSel = form.intfDocMgmtSrch.watch("kwdSel");

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        pgeStore?.form && (form.intfDocMgmtSrch.setValues(pgeStore.form), handler.getIntfDocMgmtLst(pgeStore?.page));
        // handler.getIntfDocMgmtLst();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.intfDocMgmtSrch.schema.intfId}></Group.Control>
                            <Group.Control {...form.intfDocMgmtSrch.schema.inexTpCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfDocMgmtSrch.schema.sndrcvTpCd}></Group.Control>
                            <Group.Control {...form.intfDocMgmtSrch.schema.sndrcvDvnCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Label label={"L_KWD"} />
                            <Group.Col padding={1}>
                                <Layout direction="row" gap={1}>
                                    <FormControl {...form.intfDocMgmtSrch.schema.kwdSel} />
                                    <FormControl {...form.intfDocMgmtSrch.schema.kwdTxt} readOnly={!kwdSel} />
                                </Layout>
                            </Group.Col>
                            <Group.Control {...form.intfDocMgmtSrch.schema.actvtYn}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.intfDocMgmtSrch.reset();
                                    form.intfDocMgmtSrch.setValues({
                                        bsopClsfCd: "OSC",
                                        inexTpCd: "",
                                        sndrcvTpCd: "",
                                        sndrcvDvnCd: "",
                                        kwdSel: "",
                                        kwdTxt: "",
                                        actvtYn: "",
                                    });
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getIntfDocMgmtLst();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.intfDocMgmtSrch.grid}
                            data={intfDocMgmtLstData}
                            render={render.grid_intfDocMgmtSrch}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.osci0113009s);
                        }}
                    />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
